var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1445 11.1445C10.9336 11.3555 10.5469 11.3555 10.3359 11.1445L5.69531 6.46875L1.01953 11.1445C0.808594 11.3555 0.421875 11.3555 0.210938 11.1445C0 10.9336 0 10.5469 0.210938 10.3359L4.88672 5.66016L0.210938 1.01953C0 0.808594 0 0.421875 0.210938 0.210938C0.421875 0 0.808594 0 1.01953 0.210938L5.69531 4.88672L10.3359 0.210938C10.5469 0 10.9336 0 11.1445 0.210938C11.3555 0.421875 11.3555 0.808594 11.1445 1.01953L6.46875 5.66016L11.1445 10.3359C11.3555 10.5469 11.3555 10.9336 11.1445 11.1445Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.8700d2308cc1f239b6462f4a6ef0b150.svg";
export { ForwardRef as ReactComponent };